/**
 * Created by Jew on 7/24/2017.
 */
import { AfterViewInit, Component, ElementRef, Inject, OnInit, ViewChild} from '@angular/core';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef as MatDialogRef, MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { MatLegacyTableDataSource as MatTableDataSource } from '@angular/material/legacy-table';
import { IdexService } from 'app/idex.service';
import { Router } from '@angular/router';
import { Toast } from 'app/shared/toast/toast';
import { AddUserCompanyComponent } from 'app/admin/add-user-company/add-user-company.component';
import { AddGroupCompanyComponent } from 'app/admin/add-group-company/add-group-company.component';
import { MatSort } from '@angular/material/sort';
import { RestDataSource } from 'app/shared/rest-data-source';
import { SelectionModel } from '@angular/cdk/collections';
import { AdminApi } from '../admin-api';
import { PaginatorComponent } from 'app/shared/paginator';
import { TranslateService } from '@ngx-translate/core';

@Component({
   selector: 'app-add-to-group',
   templateUrl: './add-to-group.component.html',
   styleUrls: ['./add-to-group.component.css']
})
export class AddToGroupComponent implements OnInit, AfterViewInit {
   @ViewChild(MatSort) sort: MatSort;
   @ViewChild(PaginatorComponent) paginator: PaginatorComponent;
   @ViewChild('wrapper') wrapper: ElementRef;
   @ViewChild('e') e: ElementRef;
   error: string;
   listMember: any;
   user: any;
   pageIndex = 1;
   pageSize = 50;
   private timer: any;
   searchFocused: boolean;
   searchResult: string[];
   searchSize = 8;
   siteCode: string;

   q = '';
   tin: any;
   show = true;
   type: boolean;

   displayedColumns = ['select','group_name'];
   siteName: any = '';

   dataSource = new RestDataSource<any>();
   selection = new SelectionModel<any>(true, []);
   selectedRowIndex = 0;

   usernames: string[];
   numOfSearchChar = 2;

   constructor(@Inject(MAT_DIALOG_DATA) private data: any,
   public dialogRef: MatDialogRef<AddToGroupComponent>,
      private api: AdminApi, private translate: TranslateService,
      public service: IdexService, private router: Router, private toast: Toast, public dialog: MatDialog) {
      this.user = this.service.user;
      this.usernames = data.usernames;
   }
   ngAfterViewInit(): void {
      this.onSearch();
   }

   ngOnInit() {
      this.tin = window.localStorage.getItem('tin');
   }

   toggleSelection(row: any) {
      this.dataSource.toggle(row);
   }

   onSearchFocus() {
      this.searchFocused = true;
   }

   onSearchBlur() {
      setTimeout(() => {
         this.searchFocused = false;
      }, 300);
   }

   selectSearchItem(item: any) {
      setTimeout(() => {
         this.searchFocused = false;
      }, 100);
      this.addToGroup(item);
   }

   onSearchChange(input: any) {
      this.searchResult = null;
      if (this.timer) {
         clearTimeout(this.timer);
      }
      const q = input.value.trim();
      if (q.length < this.numOfSearchChar) {
         return;
      }

      this.timer = setTimeout(() => {
         this.timer = null;
         const results = this.listMember.filter(g => g.id.toLowerCase().includes(q.toLowerCase()));
         if(results && results.length > 0) {
            this.searchResult = results.slice(0,this.searchSize);
         } else {
            this.searchResult = [];
         }
      }, 300);
   }

   onSearch(): void {
      this.e.nativeElement.blur();
      this.q = this.q.trim();
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
      this.dataSource.clearSelection();
      this.dataSource.setFilter({'tin': this.tin, 'searchText': this.q});
      this.pageIndex = 1;
      this.service.listCompanyGroupWithUsername(this.tin, this.q, this.usernames)
            .subscribe(
               result => {
                  this.listMember = result;
                  let page = this.listMember.slice((this.pageIndex - 1) * this.pageSize, this.pageIndex * this.pageSize);
                  const data = {
                     content: page,
                     totalElements: result.length
                  }
                  this.dataSource.loaded(data);
                  this.dataSource.loadData();
      })
      this.dataSource.changes.subscribe((params: any) => {
         this.sortData(this.listMember);
         let page = this.listMember.slice((this.pageIndex - 1) * this.pageSize, this.pageIndex * this.pageSize);
         const data = {
            content: page,
            totalElements: this.listMember.length
         }
         this.dataSource.loaded(data);
      });
   }

   pageChange(): void {
      if (this.paginator.size !== undefined) {
         this.pageSize = this.paginator.size;
      }
      this.pageIndex = this.paginator.page + 1;
      this.dataSource.loadData();
   }

   async addToGroups() {
      let cnt = 0;
      for(let username of this.usernames){
         for(let item of this.dataSource.selected){
            await this.api.addToGroup(item.id,username);
         }
         ++cnt;
      }
      if (cnt === this.usernames.length){
         this.translate.get('company.add-to-group-success').subscribe(s => {
            this.toast.success(s.toString())
         });
      }
      this.dialogRef.close();
   }

   async addToGroup(item: any) {
      let cnt = 0;
      for(let username of this.usernames){
         await this.api.addToGroup(item.id,username);
         ++cnt;
      }
      if (cnt === this.usernames.length){
         this.translate.get('company.add-to-group-success').subscribe(s => {
            this.toast.success(s.toString())
         });
      }
      this.dialogRef.close();
   }

   sortData(data: []) {
      data.sort((a: any, b: any) => {
         let comparatorResult = 0;
         comparatorResult = a.name.localeCompare(b.name);
         return comparatorResult;
      });
     }
}
